// ==================== SERVICIO DE MATERIALES ====================
// Funciones para interactuar con la API de materiales

import api from './api';

// ==================== OBTENER MATERIALES ACTIVOS ====================
export const obtenerMateriales = async () => {
  try {
    const response = await api.get('/materiales');
    return response.data;
  } catch (error) {
    console.error('Error al obtener materiales:', error);
    throw error;
  }
};

// ==================== OBTENER MATERIALES COMPLETADOS ====================
export const obtenerMaterialesCompletados = async () => {
  try {
    const response = await api.get('/materiales-completados');
    return response.data;
  } catch (error) {
    console.error('Error al obtener materiales completados:', error);
    throw error;
  }
};

// ==================== CREAR MATERIAL ====================
export const crearMaterial = async (materialData) => {
  try {
    const url = '/materiales';
    const response = await api.post(url, materialData);
    return response.data;
  } catch (error) {
    console.error('❌ Error en crearMaterial:', error);
    console.error('❌ Response:', error.response);
    throw error;
  }
};

// ==================== ACTUALIZAR MATERIAL ====================
export const actualizarMaterial = async (materialId, materialData) => {
  try {
    const response = await api.put(`/materiales/${materialId}`, materialData);
    return response.data.material;
  } catch (error) {
    console.error('Error al actualizar material:', error);
    throw error;
  }
};

// ==================== ACTUALIZAR PROCESO DE MATERIAL ====================
export const actualizarProcesoMaterial = async (materialId, procesoData) => {
  try {
    const response = await api.put(`/materiales/${materialId}/proceso`, procesoData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar proceso de material:', error);
    throw error;
  }
};

// ==================== DESCOMPLETAR PROCESO DE MATERIAL ====================
export const descompletarProcesoMaterial = async (materialId, nombreProceso) => {
  try {
    const response = await api.put(`/materiales/${materialId}/descompletar-proceso/${nombreProceso}`, {});
    return response.data;
  } catch (error) {
    console.error('❌ Error al descompletar proceso de material:', error);
    throw error;
  }
};

// ==================== ELIMINAR MATERIAL ====================
export const eliminarMaterial = async (materialId) => {
  try {
    const response = await api.delete(`/materiales/${materialId}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar material:', error);
    throw error;
  }
};

// ==================== COMPLETAR MATERIAL ====================
export const completarMaterial = async (materialId) => {
  try {
    const response = await api.post(`/materiales-completados/completar/${materialId}`, {});
    return response.data;
  } catch (error) {
    console.error('Error al completar material:', error);
    throw error;
  }
};

// ==================== ELIMINAR MATERIAL COMPLETADO ====================
export const eliminarMaterialCompletado = async (materialId) => {
  try {
    const response = await api.delete(`/materiales-completados/${materialId}`);
    return response.data;
  } catch (error) {
    // No loguear errores 404, son esperados cuando el material ya fue eliminado
    if (error.response?.status !== 404) {
      console.error('Error al eliminar material completado:', error);
    }
    throw error;
  }
};

// ==================== RESTAURAR MATERIAL ====================
export const restaurarMaterial = async (materialId) => {
  try {
    const response = await api.post(`/materiales-completados/restaurar/${materialId}`, {});
    return response.data;
  } catch (error) {
    console.error('Error al restaurar material:', error);
    throw error;
  }
};
